export enum StudyStatus {
  Nothing_Submitted = 0,
  Draft = 1,
  Submitted = 2,
  Denied = 3,
  Approved = 4,
}
